// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import eyeIcon from "@/assets/icons/eye.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type EyeIconProps = Omit<IconProps, "name">;

export function EyeIcon(props: EyeIconProps): React.ReactNode {
  return <Icon name={eyeIcon} {...props} />;
}
